<template>
  <div class="sec_wrap">
    <div class="search_box_wrap">
      <div class="search_box">
        <input
          type="search"
          placeholder="질문 검색"
          v-model.trim="params.searchText"
          @keyup.enter="fnSearch"
        />
        <i class="i_search pnt" @click="fnSearch"></i>
      </div>
    </div>
    <div class="filter_wrap">
      <ul>
        <li
          class="pnt"
          :class="{ on: params.selectedFilter === item.value }"
          v-for="item in filters"
          :key="item.value"
          @click="fnFilter(item.value)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div class="sub_filter_wrap">
      <div class="toggle_box" v-if="isMyPlace">
        <span>우리동네만 보기</span>
        <div class="toggle_switch">
          <input type="checkbox" id="switch" v-model="areaSwitch" /><label
            for="switch"
          ></label>
        </div>
      </div>
      <div v-else>
        총<span class="error"> {{ totalCnt }}</span
        >개의 검색 결과
      </div>
      <div class="select_box" v-if="isSort">
        <button @click="openSortModal">
          {{ params.selectedSort.label }}<i class="i_select_s"></i>
        </button>
      </div>
    </div>
    <SortModal
      :value="params.selectedSort"
      :show="isSortModal"
      @close="closeSortModal"
    />
  </div>
</template>

<script>
import SortModal from './modal/SortModal';

export default {
  name: 'component-community-section-search',
  description: '커뮤니티 > 검색 영역',
  components: {
    SortModal,
  },
  props: {
    isMyPlace: {
      type: Boolean,
      default: false,
    },
    isSort: {
      type: Boolean,
      default: true,
    },
    totalCnt: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      params: {
        selectAreaSwitch: false,
        searchText: '',
        selectedFilter: '',
        selectedSort: { label: '최신 순', value: 'CREATED_AT_DESC' },
      },
      filters: [
        { label: '휴대폰', value: 'MOBILE' },
        { label: '인터넷', value: 'INTERNET' },
        { label: '알뜰폰', value: 'MVNO' },
        { label: '요금제', value: 'PLAN' },
        { label: '렌탈', value: 'RENTAL' },
        { label: '매장', value: 'STORE' },
      ],
      isSortModal: false,
      areaSwitch: false,
      keyword: '',
    };
  },
  created() {
    this.params.searchText =
      this.$route.query.keyword != '' ? this.$route.query.keyword : '';
  },
  watch: {
    areaSwitch() {
      this.params.selectAreaSwitch = this.areaSwitch;
      this.$emit('update', this.params);
    },
    '$route.query.keyword'(val) {
      if (val) this.params.searchText = val;
    },
  },
  methods: {
    fnSearch() {
      if (!this.params.searchText.trim()) return;

      if (this.$route.query.keyword) {
        const recentWords =
          JSON.parse(localStorage.getItem('recent-keywords')) || [];

        recentWords.forEach((item, idx) => {
          if (item == this.params.searchText.trim()) recentWords.splice(idx, 1);
        });

        recentWords.unshift(this.params.searchText.trim());

        if (recentWords.length > 3) recentWords.splice(3);
        localStorage.setItem('recent-keywords', JSON.stringify(recentWords));

        this.$router
          .push({
            name: 'Knowhow.List',
            query: { keyword: this.params.searchText },
          })
          .catch(() => {});
      }
      this.$emit('update', this.params);
    },
    fnFilter(value) {
      // 같은항목 중복 클릭시 전체리스트
      if (value === this.params.selectedFilter) {
        this.params.selectedFilter = '';
      } else {
        this.params.selectedFilter = value;
      }
      this.$emit('update', this.params);
    },
    openSortModal() {
      this.isSortModal = true;
    },
    closeSortModal(val) {
      if (val) {
        this.params.selectedSort = val;
        this.$emit('update', this.params);
      }
      this.isSortModal = false;
    },
  },
};
</script>

<style></style>
